/**
 * ConfigToggle — Switch M3 para a tela /settings.
 * Prefixo Config conforme isolamento F3.
 * A11y: focus-visible, aria-checked semantico via role="switch".
 */

interface ConfigToggleProps {
  readonly id: string;
  /** Rotulo acessivel do toggle (visivel em leitor de tela) */
  readonly ariaLabel: string;
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
}

export function ConfigToggle({ id, ariaLabel, checked, onChange }: ConfigToggleProps): JSX.Element {
  return (
    <label className="cfg-toggle" htmlFor={id} aria-label={ariaLabel}>
      <input
        className="cfg-toggle-input"
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        role="switch"
        aria-checked={checked}
      />
      {/* Track com thumb interno — animacao via CSS screen-config.css */}
      <span className="cfg-toggle-track" aria-hidden="true">
        <span className="cfg-toggle-thumb" />
      </span>
    </label>
  );
}
